import { isZendeskEnvProd } from "@/env/config";

const employersZendeskUrls = {
  ["健康診断"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31937903357849-2024%E5%B9%B4%E5%BA%A6%E5%81%A5%E5%BA%B7%E8%A8%BA%E6%96%AD%E3%81%AE%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B-%E4%BA%8B%E6%A5%AD%E6%89%80%E3%81%AE%E7%9A%86%E6%A7%98%E3%81%B8",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9656159116047-2024%E5%B9%B4%E5%BA%A6%E5%81%A5%E5%BA%B7%E8%A8%BA%E6%96%AD%E3%81%AE%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B-%E4%BA%8B%E6%A5%AD%E6%89%80%E3%81%AE%E7%9A%86%E6%A7%98%E3%81%B8",
  },
  ["マイナ保険証"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31992080783897-%E3%83%9E%E3%82%A4%E3%83%8A%E4%BF%9D%E9%99%BA%E8%A8%BC%E7%A7%BB%E8%A1%8C%E3%81%AB%E4%BC%B4%E3%81%86%E4%BA%8B%E6%A5%AD%E6%89%80%E3%81%B8%E3%81%AE%E3%81%8A%E9%A1%98%E3%81%84",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9667035448719-%E3%83%9E%E3%82%A4%E3%83%8A%E4%BF%9D%E9%99%BA%E8%A8%BC%E7%A7%BB%E8%A1%8C%E3%81%AB%E4%BC%B4%E3%81%86%E4%BA%8B%E6%A5%AD%E6%89%80%E3%81%B8%E3%81%AE%E3%81%8A%E9%A1%98%E3%81%84",
  },
  ["ヘルプ"]: {
    prod: "https://help-employers.mykenpo.com/hc/ja",
    dev: "https://help-employers.dev.mykenpo.com/hc/ja",
  },
  ["法人設定"]: {
    prod: "https://help-employers.mykenpo.com/hc/ja/articles/31948020556057-%E4%BA%8B%E6%A5%AD%E6%89%80%E6%83%85%E5%A0%B1%E3%81%AB%E5%A4%89%E6%9B%B4%E3%81%8C%E3%81%82%E3%81%A3%E3%81%9F%E3%81%A8%E3%81%8D",
    dev: "https://help-employers.dev.mykenpo.com/hc/ja/articles/9658131857935-%E4%BA%8B%E6%A5%AD%E6%89%80%E6%83%85%E5%A0%B1%E3%81%AB%E5%A4%89%E6%9B%B4%E3%81%8C%E3%81%82%E3%81%A3%E3%81%9F%E3%81%A8%E3%81%8D",
  },
  ["利用規約"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31992897832089-mykenpo%E3%81%AE%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9667194269199-mykenpo%E3%81%AE%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
  },
  ["個人情報保護方針"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/31992990011545-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E4%BF%9D%E8%AD%B7%E6%96%B9%E9%87%9D",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/9667284055951-%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E4%BF%9D%E8%AD%B7%E6%96%B9%E9%87%9D",
  },
  ["公告"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/categories/30218072859801",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/sections/9524369956367-%E5%85%AC%E5%91%8A",
  },
  ["変更申請"]: {
    prod: "https://help-employers.mykenpo.com/hc/ja/articles/31948783034393-%E9%81%A9%E7%94%A8%E4%BA%8B%E6%A5%AD%E6%89%80%E5%90%8D%E7%A7%B0-%E6%89%80%E5%9C%A8%E5%9C%B0-%E5%A4%89%E6%9B%B4-%E8%A8%82%E6%AD%A3-%E5%B1%8A%E3%81%AE%E7%94%B3%E8%AB%8B%E6%96%B9%E6%B3%95",
    dev: "https://help-employers.dev.mykenpo.com/hc/ja/articles/9658274499983-%E9%81%A9%E7%94%A8%E4%BA%8B%E6%A5%AD%E6%89%80%E5%90%8D%E7%A7%B0-%E6%89%80%E5%9C%A8%E5%9C%B0-%E5%A4%89%E6%9B%B4-%E8%A8%82%E6%AD%A3-%E5%B1%8A%E3%81%AE%E7%94%B3%E8%AB%8B%E6%96%B9%E6%B3%95",
  },
  ["健康診断予約情報一括登録ガイド"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/37736972730777",
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/10752707825551-mykenpo%E3%81%A7%E5%81%A5%E8%A8%BA%E4%BA%88%E7%B4%84%E6%83%85%E5%A0%B1%E3%81%A8%E5%95%8F%E8%A8%BA%E5%9B%9E%E7%AD%94%E3%81%8C%E5%8F%AF%E8%83%BD%E3%81%AB%E3%81%AA%E3%82%8A%E3%81%BE%E3%81%97%E3%81%9F",
  },
  ["資格喪失証明書交付申請書"]: {
    prod: "https://help-members.mykenpo.com/hc/ja/articles/31943320872729",
    dev: "https://help-members.dev.mykenpo.com/hc/ja/articles/9657197368975",
  },
  ["登録案内"]: {
    prod: "https://help-top.mykenpo.com/hc/ja/articles/54935415676953",
    // NOTE: dev環境用URLが存在しないため、prod URLを使用
    dev: "https://help-top.mykenpo.com/hc/ja/articles/54935415676953",
  },
} as const satisfies Record<string, { prod: string; dev: string }>;

export const getEmployersZendeskUrl = (
  key: keyof typeof employersZendeskUrls,
) => {
  return employersZendeskUrls[key][isZendeskEnvProd() ? "prod" : "dev"];
};
